import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "m-2 d-flex justify-end"
}
const _hoisted_5 = { class: "bg-white border-default py-1 mt-2" }

import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { checkMobile } from '../../utils/utils'
import CoursePurchase, {
  CoursePurchaseInvoice
} from '../../../api/v2/models/course_purchase'
import CoursePurchaseForm from '../../../api/v2/forms/course_purchase'
import { coursePurchaseState } from '../../stores/course_purchase'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import CoursePurchaseComponent from '../atoms_molecules/CoursePurchase.vue'
import CoursePurchaseInvoiceComponent from '../atoms_molecules/CoursePurchaseInvoice.vue'
import StripeCardPayComponent from '../atoms_molecules/StripeCardPay.vue'
import CourseMy from '../atoms_molecules/CourseMy.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CoursePurchaseDetail',
  setup(__props) {

const route = useRoute()

const mobile = ref(false)
const tab = ref<1 | 0>(0)
const coursePurchase = ref<CoursePurchase | null>(null)
const coursePurchaseInvoices = ref<CoursePurchaseInvoice[]>([])

const user = computed(() => userState.user)
const isLoading = computed(() => coursePurchaseState.isLoading)
const errorMessage = computed(() => coursePurchaseState.errorMessage)
const lastCoursePurchaseInvoice = computed(() => coursePurchaseInvoices.value[0])

const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: '購入済み',
    disabled: false,
    exact: true,
    to: '/classroom/subscription'
  }
]

const getCoursePurchase = () => {
  coursePurchaseState.getCoursePurchase(route.params.coursePurchaseId as any).then((response) => {
    if (response) {
      coursePurchase.value = response.coursePurchase
      coursePurchaseInvoices.value = response.coursePurchaseInvoices
    }
  })
}

const onPay = async (tokenId: string) => {
  const coursePurchaseForm = new CoursePurchaseForm()
  coursePurchaseForm.coursePurchaseId = coursePurchase.value!.id
  coursePurchaseForm.token = tokenId
  coursePurchaseForm.email = user.value!.email
  await coursePurchaseState.updateCoursePurchase({
    coursePurchaseForm
  })
  getCoursePurchase()
  userState.getUser()
}

onMounted(() => {
  mobile.value = checkMobile()
  headerState.setTitle('購入済み')
  footerState.setFooterDefault()
  getCoursePurchase()
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: '購入済み', to: '/classroom/subscription' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "9",
        class: "p-4 bg-white"
      }, {
        default: _withCtx(() => [
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createVNode(CoursePurchaseComponent, { coursePurchase: coursePurchase.value }, null, 8 /* PROPS */, ["coursePurchase"]),
          (coursePurchase.value && coursePurchase.value.needUpdateCard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(StripeCardPayComponent, {
                  cardComplete: onPay,
                  title: user.value.currentSchoolName,
                  description: '分割払いの更新',
                  mail: user.value.email,
                  purchasePrice: lastCoursePurchaseInvoice.value ? lastCoursePurchaseInvoice.value.amountPaid : 0
                }, null, 8 /* PROPS */, ["title", "mail", "purchasePrice"])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex px-4" }, [
              _createElementVNode("div", { class: "w-25 p-1" }, " お支払い日時 "),
              _createElementVNode("div", { class: "w-25 p-1" }, " お支払い金額 "),
              _createElementVNode("div", { class: "w-25 p-1" }, " ステータス "),
              _createElementVNode("div", { class: "w-25 p-1" })
            ], -1 /* CACHED */)),
            _createVNode(_component_v_divider, { class: "my-2" }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coursePurchaseInvoices.value, (coursePurchaseInvoice, index) => {
              return (_openBlock(), _createBlock(CoursePurchaseInvoiceComponent, {
                class: "mt-1",
                key: index,
                coursePurchaseInvoice: coursePurchaseInvoice
              }, null, 8 /* PROPS */, ["coursePurchaseInvoice"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})